import { useDataProvider } from 'ra-core';
import { CustomBulkAction } from '../Moonstar/CustomBulkAction';
import { ResourcesValue } from '../resources';

export const RoleBulkActions = () => {
  const dataProvider = useDataProvider();

  return (
    <CustomBulkAction
      mutationFn={async (ids) => {
        const results = await Promise.allSettled(
          ids.map((id) => dataProvider.delete(ResourcesValue.ROLES, { id }))
        );
        const failure = results.find((result) => result.status === 'rejected');

        if (failure) {
          throw failure.reason;
        }

        return results;
      }}
      label="ra.action.delete"
      variant="destructive"
      requireConfirmation
    />
  );
};
